'use client';

import dynamic from 'next/dynamic';

const LoadingModal = dynamic(() => import('~/components/loading-modal'), {
  ssr: false,
});


function Loading() {
  // You can add any UI inside Loading, including a Skeleton.

  return (
      <LoadingModal />
  )
}

export default Loading;
